<template>
  <div class="personas-table">
    <load-screen ref="loader" :startingText="$t('common.uploading')"></load-screen>
    <div class="personas-table__list">
      <div class="personas-table__item"
        v-for="(item, index) in personas"
        :key="index">
        <div class="personas-table__main">
          <div class="personas-table__content">
            <input :id="'persona-file'+index" type="file" class="personas-table__img-upload"
              accept="image/jpeg, image/png"
              @change="imgUploaded($event.target.files[0], item)"/>
            <label :for="'persona-file'+index"
              class="personas-table__img-show"
              :style="getBackground(item.profile_picture_url)">
            </label>
            <in label="name" 
              class="personas-table__name" 
              :value="item.name"
              @blur="onNameInput(item, $event.target.value)"/>
            <fai v-if="item.id" 
              class="personas-table__del" 
              icon="ban"
              @click="deletePersona(item, index)"/>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import axios from '@/axios'
export default {
  data () {
    return {
      personas: []
    }
  },

  computed: {
  },

  mounted () {
    this.fetchPersonas()
  },

  methods: {
    async fetchPersonas () {
      try {
        let res = await axios.get('/api/personas/list')
        this.personas = res.data.personas
        this.addTemplate()
      } catch (e) {
        console.error(e)
      }
    },

    addTemplate () {
      this.personas.push({
        name: '',
        profile_picture_url: null
      })
    },

    // ===============================================================
    // change

    async onNameInput (item, text) {
      try {
        if(text === '') return
        if(item.id) {
          if(item.name === text) return
          item.name = text
          let res = await axios.patch('/api/personas/update', {
            personas: [item]
          })
          this.notify('success', 'view.settings.success.personaEdit')
          item.id = res.data.ids[0]
          item.outside_id = res.data.outsideIdsToReturn[0]
        } else {
          item.name = text
          if(item.profile_picture_url) {
            await this.createNew(item)
          }
        }
      } catch(e) {
        console.error(e)
      }
    },

    async imgUploaded (file, item) {
      try {
        if(file.size >= 1024 * 1024 * 8) {
          alert('too big :(')
          return
        }
        
        //let uploadedURL = await this.uploadToS3(file)
        if(item.id) {
          let uploadedURL = await this.uploadToS3(file)
          item.profile_picture_url = uploadedURL
          let res = await axios.patch('/api/personas/update', {
            personas: [item]
          })
          this.notify('success', 'view.settings.success.personaEdit')
          item.id = res.data.ids[0]
          item.outside_id = res.data.outsideIdsToReturn[0]
        } else {
          item.profile_picture_url = URL.createObjectURL(file)
          item.file = file
          if(item.name !== '') {
            this.createNew(item)
          }
        }
      } catch (e) {
        console.error(e)
      }
    },

    async createNew (item) {
      try {
        this.$refs.loader.show()
        let uploadedUrl = await this.uploadToS3(item.file)
        delete item.file
        item.profile_picture_url = uploadedUrl
        let res = await axios.post('/api/personas/create', {
          personas: [item]
        })
        item.id = res.data.ids[0]
        item.outside_id = res.data.outsideIdsToReturn[0]
        this.addTemplate()
        this.$refs.loader.hide()
        this.notify('success', 'view.settings.success.personaCreate')
      } catch (e) {
        this.$refs.loader.hide()
        this.notify('error', 'view.settings.error.personaCreate')
        throw e
      }
    },

    async deletePersona (item, index) {
      try {
        await axios.delete('/api/personas/delete', {
          data: {
            personas: [{
              id: item.id,
              outside_id: item.outside_id
            }]
          }
        })
        this.personas.splice(index, 1)
        this.notify('success', 'view.settings.success.personaDelete')
      } catch (e) {
        this.notify('error', 'view.settings.error.personaDelete')
        console.error(e)
      }
    },

    async uploadToS3 (file) {
      try {
        const res = await axios.get('/api/personas/signed-url?type='+file.type)
        const signedUrl = res.data.url
        const options = {
          headers: {
            'Content-Type': file.type,
            'x-amz-acl': 'public-read'
          }
        }
        const resS3 = await axios.put(signedUrl, file, options)
        return resS3.request.responseURL.replace(/\?.*$/,'')
      } catch (e) {
        throw e
      }
    },

    // ==============================================================
    // misc

    getBackground (profile_picture_url) {
      if(profile_picture_url) {
        return { 
          'background-image': 'url('+profile_picture_url+')',
          'background-position': 'center',
          'background-size': 'cover'
        }
      } else {
        return {
          'border-style': 'solid',
          'border-width': '1px',
          'border-color': 'chocolate',
          'margin-top': '-2px',
        }
      }
    }
  }
}
</script>

<style lang="scss">
.personas-table {
  &__list {
    display: flex;
    flex-wrap: wrap;
    margin: -9px;
  }

  &__item {
    margin: 8px;
    position: relative;
    width: 30%;
  }

  &__main {
    @include boxShadow(-2px, 2px, 9px, -10px, rgba(0, 0, 0, 0.8));
    display: flex;
    justify-content: center;
    background: white;
    border-radius: 4px;
  }

  &__gradient {
    background-color: $primary;
    position: relative;
    border-radius: 4px 0px 0px 4px;
    width: 6px;
  }

  &__content {
    padding: 18px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  &__img-upload {
    width: 0.1px;
    height: 0.1px;
    opacity: 0;
    overflow: hidden;
    position: absolute;
    z-index: -1;
  }

  &__img-show {
    @include boxShadow(0px, 1px, 4px, -3px, rgba(0, 0, 0, 0.9));
    cursor: pointer;
    width: 80px;
    height: 80px;
    border-radius: 50%;
    margin-bottom: 6px;
  }

  &__del {
    cursor: pointer;
    position: absolute;
    font-size: 1.2em;
    right: calc(0% + 8px);
    top: calc(0% + 8px);
  }
}
</style>
